<template>
  <div class="mb-4 category-wrapper">
    <p class="h3">{{ title }}</p>
    <p v-if="description" class="text-muted">{{ description }}</p>
    <div class="mb-3">
      <LunchMenuItem v-bind="item" v-for="(item, idx) in items" :key="`${slug}-item-${idx}`" />
    </div>
  </div>
</template>
<script>
import LunchMenuItem from "./LunchMenuItem";

export default {
  name: "LunchMenuCategoryListing",
  components: {
    LunchMenuItem,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
      required: false,
    },
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.category-wrapper {
  padding-top: $spacer-5;
  margin-top: -$spacer-5;
}
</style>
